module.exports = function anonymous(locals, escapeFn, include, rethrow
/**/) {
"use strict";
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
        .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
    ; __append("<header></header> <div class=\"card card-body filter-card\"> <div id=\"carrier_picker\" class=\"mr-4\"></div> <div id=\"facility_type_picker\" class=\"mr-4\"></div> <div id=\"tracker_loader\"></div> </div> <div class=\"row\"> <div class=\"col-sm-8\"> <div class=\"us-map\"></div> </div> <div class=\"col-sm-4\"> <div class=\"facility-chart\"></div> <div class=\"facility-selector\"> <h4>Facilities</h4> <table class=\"table table-sm table-hover\"> <tbody></tbody> </table> </div> </div> </div> ")
  return __output.join("");

}


//////////////////
// WEBPACK FOOTER
// ./app/components/pages/carrier_activity_map/template.ejs
// module id = 1634
// module chunks = 1